import React from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import { FormControl } from '@material-ui/core'
import { SelectProps } from '@material-ui/core/Select/Select'
import { isRtl } from '../../i18nInit'

export interface YumSelectProps extends SelectProps {
  label?: string
  startIcon?: any
  StartIconComponent?: any
  startInactiveIcon?: any
  StartInactiveIconComponent?: any
  sideMargin?: number
}

class YumSelect extends React.Component<YumSelectProps> {
  constructor(props: any) {
    super(props)
    this.state = {
      shrink: false, // this is used to shrink/unshrink the label
    }
  }

  shrinkLabel = (event: any) => {
    const { onFocus } = this.props
    this.setState({ shrink: true })
    onFocus && onFocus(event) // let the child do its thing
  }

  unShrinkLabel = (event: any) => {
    const { onBlur } = this.props
    if (event.target.value.length === 0 && !event.target.validity.badInput) {
      this.setState({ shrink: false }) // gotta make sure the input is empty before shrinking the label
    }
    onBlur && onBlur(event) // let the child do its thing
  }

  render() {
    const {
      children,
      label,
      startIcon,
      StartIconComponent,
      startInactiveIcon,
      StartInactiveIconComponent,
      value,
      sideMargin,
      ...other
    } = this.props
    const hasStartIcon = startIcon || StartIconComponent
    const StartIcon = startIcon ? startIcon : null
    const StartInactiveIcon = startInactiveIcon ? startInactiveIcon : null

    // @ts-ignore
    const noEmptyChoice = children && React.Children.count(children) > 0 ? children[0]?.props?.value !== '' : false

    // @ts-ignore
    const shrink = noEmptyChoice || (value !== null && value !== undefined && value !== '') || this.state.shrink

    return (
      <FormControl margin="none" variant="filled" style={{ width: '100%' }}>
        {label && (
          <InputLabel
            shrink={shrink}
            style={
              hasStartIcon
                ? isRtl
                  ? {
                      marginRight: sideMargin ? sideMargin : '33px',
                    }
                  : {
                      marginLeft: sideMargin ? sideMargin : '33px',
                    }
                : {}
            }
          >
            {label}
          </InputLabel>
        )}
        <Select
          fullWidth={true}
          native
          inputProps={{
            id: 'custom-type',
            style: {
              backgroundColor: 'transparent',
              border: 'none',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              color: 'inherit',
              textTransform: 'inherit',
              paddingTop: label ? '18px' : '12px',
              paddingBottom: label ? '4px' : '12px',

              marginLeft: isRtl ? 0 : hasStartIcon ? '-42px' : 0,
              paddingLeft: isRtl ? '19px' : hasStartIcon ? '42px' : '10px',

              marginRight: isRtl ? (hasStartIcon ? '-42px' : 0) : 0,
              paddingRight: isRtl ? (hasStartIcon ? '42px' : '10px') : '19px',
            },
          }}
          disableUnderline
          startAdornment={
            StartIcon ? (
              <InputAdornment position={'start'} style={{ marginTop: 0 }}>
                {StartInactiveIcon && !shrink ? <StartInactiveIcon /> : <StartIcon />}
              </InputAdornment>
            ) : StartIconComponent ? (
              <InputAdornment position={'start'} style={{ marginTop: 0 }}>
                {StartInactiveIconComponent && !shrink ? StartInactiveIconComponent : StartIconComponent}
              </InputAdornment>
            ) : (
              ''
            )
          }
          onFocus={this.shrinkLabel}
          onBlur={this.unShrinkLabel}
          value={value}
          {...other}
        >
          {children}
        </Select>
      </FormControl>
    )
  }
}

export default YumSelect
